import { render, staticRenderFns } from "./AccessoryFile.vue?vue&type=template&id=f40cbd8c&scoped=true"
import script from "./AccessoryFile.vue?vue&type=script&lang=js"
export * from "./AccessoryFile.vue?vue&type=script&lang=js"
import style0 from "./AccessoryFile.vue?vue&type=style&index=0&id=f40cbd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40cbd8c",
  null
  
)

export default component.exports